// Utilitaire pour charger la configuration centralisée depuis domain-config.json
import domainConfigData from '../../domain-config.json';

export interface DomainEnvironmentConfig {
  PUBLIC_API_URL: string;
  PUBLIC_ENABLE_FEATURE_IA_SUGGESTION: string;
  DECLARATION_SAV_URL: string;
  PRO_URL: string;
  HOME_DIPROPNEU_URL?: string;
  SOUSCRIPTION_DIPROPNEU_URL?: string;
  ENABLE_SENTRY?: string;
}

export interface DomainConfig {
  title: string;
  faviconUrl: string;
  router: string;
  brand: string;
  environment: DomainEnvironmentConfig;
}

export interface DomainConfigData {
  domains: Record<string, DomainConfig>;
  defaults: DomainConfig;
  routerNames: Record<string, string>;
}

// Configuration centralisée
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const domainConfig: DomainConfigData = domainConfigData as DomainConfigData;

/**
 * Obtient la configuration pour un hostname donné
 */
export function getDomainConfig(hostname?: string): DomainConfig {
  if (!hostname) {
    hostname = window.location.hostname;
  }

  const port = window.location.port;
  const hostnameWithPort = port ? `${hostname}:${port}` : hostname;

  // Essayer avec le port d'abord, puis sans
  const config = domainConfig.domains[hostnameWithPort] ||
                 domainConfig.domains[hostname] ||
                 domainConfig.defaults;

  console.log('[Domain Config] Hostname:', hostnameWithPort, 'Config:', config);

  return config;
}

/**
 * Obtient uniquement la configuration d'environnement
 */
export function getEnvironmentConfig(hostname?: string): DomainEnvironmentConfig {
  return getDomainConfig(hostname).environment;
}

/**
 * Obtient le nom du router pour un hostname
 */
export function getRouterName(hostname?: string): string {
  return getDomainConfig(hostname).router;
}

// Fonction getRouterKey supprimée - on utilise directement getRouterName()
// qui retourne les strings du JSON sans conversion inutile

/**
 * Obtient la marque depuis la configuration
 */
export function getBrandFromConfig(hostname?: string): string {
  return getDomainConfig(hostname).brand;
}

/**
 * Vérifie si on est en développement
 */
export function isDevelopment(hostname?: string): boolean {
  if (!hostname) {
    hostname = window.location.hostname;
  }

  return hostname === 'localhost' ||
         hostname === '127.0.0.1' ||
         hostname.includes('dev') ||
         hostname.includes('-dev');
}

/**
 * Obtient tous les noms de routeurs disponibles
 */
export function getAvailableRouterNames(): Record<string, string> {
  return domainConfig.routerNames;
}

/**
 * Obtient tous les domaines configurés
 */
export function getAllDomains(): Record<string, DomainConfig> {
  return domainConfig.domains;
}